import React, { useEffect } from 'react';
import { Modal, Button, FormControl } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useFormikContext } from 'formik';
import CheckIcon from 'mdi-react/CheckIcon';
import CloseCircleOutline from 'mdi-react/CloseCircleOutlineIcon';
import classNames from 'classnames';

import { changeActiveInput } from 'modules/kiosk/containers/Kiosk/services/actions';
import { isErrorVerify } from '../VerifyPhoneBtn/actions';
import styles from './VetifyModal.module.scss';

type Props = {
  show: boolean;
  successVerify: boolean;
  mode: 'kiosk' | 'main';
  errorVerify: boolean;
  errorMsg: any;
  onHide: () => void;
  successVerifyModal: () => void;
  onClickVerify: () => void;
  code?: string | null;
};

const VerifyModal: React.FC<Props> = ({
  show,
  mode,
  successVerify,
  onHide,
  successVerifyModal,
  onClickVerify,
  errorVerify,
  code = '',
  errorMsg,
}) => {
  const formik = useFormikContext();
  const dispatch = useDispatch();

  // @ts-ignore
  const input = formik.values.keybVerifyCode;

  const onVerify = () => {
    if (input === code) {
      successVerifyModal();
    } else {
      dispatch(isErrorVerify(true));
    }
  };

  useEffect(() => {
    if (show) {
      dispatch(changeActiveInput('keybVerifyCode'));
    }
  }, [show, code]);

  return (
    <React.Fragment>
      {successVerify ? (
        <Modal
          show={show}
          onHide={onHide}
          size={mode === 'main' ? 'sm' : 'lg'}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className={mode === 'main' ? '' : styles.modal}
          backdrop="static"
        >
          <div className={classNames(styles.content, 'd-flex')}>
            <h3 className="d-flex align-items-center justify-content-center w-100">
              <CheckIcon size={38} className="text-success mr-3" />
              Номер підтвердженно
            </h3>
          </div>
        </Modal>
      ) : (
        <Modal
          show={show}
          onHide={onHide}
          size={mode === 'main' ? 'sm' : 'lg'}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          className={mode === 'main' ? '' : styles.modal}
          onClick={(e: any) => e.stopPropagation()}
        >
          <div className={styles.content}>
            <Modal.Header className="border-bottom-0 justify-content-end">
              <Button variant="outine-light d-flex justify-content-end" onClick={onHide}>
                <CloseCircleOutline className="text-secondary" />
              </Button>
            </Modal.Header>
            <Modal.Body className="d-flex align-items-center flex-column  px-4 pb-4">
              <h5 className={`text-center ${mode === 'kiosk' ? 'display-4' : ''}`}>
                Введіть надісланний код з СМС-повідомлення:
              </h5>
              <FormControl
                pattern="[0-9]"
                name="keybVerifyCode"
                value={input}
                className={`${errorVerify ? '' : 'mb-3'} w-50 mt-2`}
                onClick={(e: any) => {
                  e.stopPropagation();
                  dispatch(changeActiveInput('keybVerifyCode'));
                }}
                onChange={(e) => formik.setFieldValue('keybVerifyCode', e.target.value)}
                autoComplete="off"
              />
              <small className="text-danger my-2">
                {errorVerify ? 'Код має співпадати з тим, що прийшов на телефон' : ''}
              </small>
              {errorMsg ? <small className="text-danger d-flex align-items-center my-2">{errorMsg}</small> : null}
            </Modal.Body>
            <Modal.Footer className="justify-content-around border-top-0 mt-3 mb-4">
              <Button variant="secondary" onClick={onClickVerify} className="py-2 text-uppercase w-140 \">
                Надіслати повторно
              </Button>
              <Button
                onClick={onVerify}
                variant="danger"
                id="onVerifyCode"
                className="px-4 py-2 text-white text-uppercase w-140"
              >
                Підтвердити
              </Button>
            </Modal.Footer>
          </div>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default VerifyModal;
